import { useContext, useMemo } from 'react';
import { UserContext } from '../../context/UserContext';

/**
 * The departments whose documents this user may open, labelled
 * "בית חולים ← מחלקה". A super admin gets every department; anyone else the
 * departments they hold a role in (any role reads, as with protocols).
 * `hospitals` from UserContext is already scoped the same way by the server.
 */
const useDocumentDepartments = () => {
  const { user, hospitals } = useContext(UserContext);

  return useMemo(() => {
    if (!user) return [];
    const roleDepartments = new Set((user.roles || []).map(role => role.department).filter(Boolean));

    const options = [];
    (hospitals || []).forEach(hospital => {
      (hospital.departments || []).forEach(department => {
        if (!user.isSuperAdmin && !roleDepartments.has(department._id)) return;
        options.push({
          id: department._id,
          hospitalId: hospital._id,
          // "←", not "->": in right-to-left text it points from the hospital to the department.
          label: `${hospital.nameHebrew} ← ${department.nameHebrew}`,
        });
      });
    });
    return options;
  }, [user, hospitals]);
};

export default useDocumentDepartments;
